var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Badge, Box, CircularProgress, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { MapsIcon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useGetMachineClientsQuery } from '../../../../application/features/machines/machine-api';
import useTranslate from '../../../../localization/helpers';
var ClientsDrawer = function (_a) {
    var _b;
    var machine = _a.machine, isOpen = _a.isOpen, onClose = _a.onClose;
    var theme = useTheme();
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('md'));
    var _d = __read(useState(), 2), userLocation = _d[0], setUserLocation = _d[1];
    var _e = useGetMachineClientsQuery(machine === null || machine === void 0 ? void 0 : machine.id, {
        skip: !(machine === null || machine === void 0 ? void 0 : machine.id)
    }), _f = _e.data, clients = _f === void 0 ? [] : _f, isFetching = _e.isFetching;
    useEffect(function () {
        if (!userLocation)
            getLocation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machine]);
    var getLocation = function () {
        navigator.geolocation.getCurrentPosition(function (position) {
            setTimeout(function () {
                setUserLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            }, 500);
        });
    };
    var navigate = function (client) {
        if (userLocation && client) {
            var baseUrl = 'https://www.google.com/maps/dir/?api=1';
            var origin_1 = "&origin=".concat(userLocation.latitude, ",").concat(userLocation.longitude);
            var dest = "&destination=".concat(client.latitude, ",").concat(client.longitude);
            var travelMode = '&travelmode=driving';
            var url = "".concat(baseUrl).concat(origin_1).concat(dest).concat(travelMode);
            window.open(url, '_blank');
        }
    };
    var onGetDirections = function (client) {
        if (!userLocation)
            navigator.geolocation.getCurrentPosition(function (position) {
                setUserLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
                navigate(client);
            }, function (error) {
                if (error.code === error.PERMISSION_DENIED) {
                    enqueueSnackbar(translate('validations.locationAccessError'), {
                        autoHideDuration: 3000,
                        variant: 'error',
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                }
                else {
                    enqueueSnackbar(translate('validations.locationError'), {
                        autoHideDuration: 3000,
                        variant: 'error',
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                }
            });
        else
            navigate(client);
    };
    return (_jsxs(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '375px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', xs: '100%' }
                }
            }
        }, variant: 'temporary', anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', open: isOpen, onClose: onClose, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    gap: '8px',
                    flexDirection: 'column',
                    borderRadius: '16px',
                    padding: '16px 20px 16px 20px'
                }, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: [_jsx(Typography, { variant: 'h6', children: translate('common.clients') }), _jsx(IconButton, { size: 'small', onClick: onClose, children: _jsx(CloseIcon, {}) })] }), _jsx(Box, { display: 'flex', flexDirection: 'column', gap: '8px', children: _jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: [_jsx(Box, { width: '80%', children: _jsx(Typography, { fontSize: '18px', fontWeight: 500, children: machine === null || machine === void 0 ? void 0 : machine.name }) }), _jsx(Box, { display: 'flex', alignItems: 'center', mr: 4, children: _jsx(Badge, { badgeContent: "".concat((_b = machine === null || machine === void 0 ? void 0 : machine.processedDocuments) !== null && _b !== void 0 ? _b : 0, " ").concat(translate('common.documents')), color: 'default', variant: 'standard', sx: {
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#E4E6EB',
                                                color: '#161C24',
                                                width: 'max-content'
                                            }
                                        } }) })] }) })] }), _jsx(Box, { sx: { padding: '0px 20px 0px 20px', display: 'flex', flexDirection: 'column', gap: '12px' }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', padding: '16px 0px 16px 0px', overflow: 'auto', gap: '10px', borderRadius: '24px', children: isFetching ? (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', children: _jsx(CircularProgress, {}) })) : clients.length === 0 && !isFetching ? (_jsx(Typography, { variant: 'body2', color: 'text.secondary', textAlign: 'center', children: tWithField('validations.notFound', 'common.clients') })) : (clients.map(function (client) { return (_jsx(Box, { padding: '8px', gap: '8px', borderRadius: '12px', boxShadow: theme.customShadows.z12, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', children: [_jsx(Box, { display: 'flex', flexDirection: 'column', gap: '8px', children: _jsx(Typography, { variant: 'body1', children: client.name }) }), _jsx(IconButton, { size: 'medium', color: 'primary', onClick: function () { return onGetDirections(client); }, children: _jsx(MapsIcon, {}) })] }) }, client.id)); })) }) })] }));
};
export default ClientsDrawer;
